import { Stack, styled, Typography, type CSSObject } from '@mui/material';

export const SearchDatabaseWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(2),
  alignItems: 'flex-start',
}));

export const SearchDatabaseImageWrapper = styled(Stack)(({ theme }) => ({
  minWidth: theme.spacing(6),
  minHeight: theme.spacing(6),
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '100%',
  background: theme.palette.greyColors?.MINUS_4,

  [theme.breakpoints.down('md')]: {
    minWidth: theme.spacing(4.5),
    minHeight: theme.spacing(4.5),
  },
}));

export const SearchDatabaseTitle = styled(Typography)(({ theme }) => ({
  letterSpacing: '-0.02em',
  marginBottom: '10px',
  background:
    'linear-gradient(180deg, #FFFFFF 0%, rgba(217, 217, 217, 0.8) 100%)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 500,
}));
